import _ from 'lodash';
import content from './pages/auth/okta-widget-assets/content.json';

export type AppContent = {
  products: { [productid: string]: ProductContent };
};

export type ProductContent = {
  brandName: string;
  homeUrl?: string;
  appName?: string;
  pageTitle?: string;
  headerText?: string;
  i18n?: any;
  footerLinks: { label: string; url: string; }[]
};

export type SettingsForApp = {
  registrationEnabled: boolean;
  managementEnabled: boolean;
  intercomEnabled: boolean;
  helpLink: string;
  passwordResetMethod: 'email' | 'username';
};

function getHostnameFromUrl(url: string) {
  const l = document.createElement("a");
  l.href = url;
  return l.hostname;
}

export function getAppNameFromDestination(url: string) {
  const hostname = getHostnameFromUrl(url);

  const appNamesMap = window.spConfig.appNames as any;
  const matchingKey = Object.keys(appNamesMap).find((key) => hostname.endsWith(key));

  return appNamesMap[matchingKey || '_default']
}

export function getSettingsForApp(appName: string): SettingsForApp {
  switch (appName) {
    case 'EAL':
      return {
        registrationEnabled: false,
        managementEnabled: false,
        intercomEnabled: false,
        helpLink: 'https://eal.org.uk/support/centre-support',
        passwordResetMethod: 'username',
      }

    default:
      return {
        registrationEnabled: true,
        managementEnabled: true,
        intercomEnabled: false,
        helpLink: 'https://enginuity.org/support/',
        passwordResetMethod: 'email',
      }
  }
}

export function getContentForApp(appName: string) {
  const appContent: ProductContent = _.merge(content.products["default"], (content as AppContent).products[appName]);
  return appContent;
}